/**
 * The pending line in Close Out's owner-approval bar (10/28):
 * office → "Waiting on Corbin · 4 days — nothing rides until it's approved."
 * owner  → "Waiting on you · 4 days — approve it here or from Quotes to OK."
 * "Owner" is the org owner setting, not the Admin role: another Admin (the
 * office manager) reads the office line.
 */
import { useApprover, waitingOnLine } from "@/lib/waiting-on-approver";

export function WaitingOnApproverText({ sentAt }: { sentAt: string | null }) {
    const { firstName: approverName, isYou } = useApprover();
    return (
        <span data-testid="waiting-on-approver">
            {isYou ? (
                <>
                    <b>{waitingOnLine("you", sentAt)}</b> — approve it here or from your Quotes to OK chip.
                </>
            ) : (
                <>
                    <b>{waitingOnLine(approverName, sentAt)}</b> — nothing rides until it&apos;s approved.
                </>
            )}
        </span>
    );
}
